var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_663_3434)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    y: 0.678711,
    width: 37.3625,
    height: 37.3625,
    rx: 9.34062,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.94006,
    cy: 28.0948,
    r: 27.7137,
    transform: "rotate(-0.403168 5.94006 28.0948)",
    fill: "url(#paint0_linear_663_3434)",
    stroke: "url(#paint1_linear_663_3434)",
    strokeWidth: 0.0572801
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 26.7682,
    cy: 14.5396,
    r: 27.7137,
    transform: "rotate(-0.403168 26.7682 14.5396)",
    fill: "url(#paint2_linear_663_3434)",
    stroke: "url(#paint3_radial_663_3434)",
    strokeWidth: 0.0572801
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.378 19.3602C30.378 25.44 25.4493 30.3687 19.3694 30.3687C13.2896 30.3687 8.36084 25.44 8.36084 19.3602C8.36084 13.2803 13.2896 8.35156 19.3694 8.35156M25.4853 19.3602C25.4853 22.7379 22.7471 25.476 19.3694 25.476C15.9917 25.476 13.2535 22.7379 13.2535 19.3602C13.2535 15.9824 15.9917 13.2443 19.3694 13.2443M22.7428 16.1207L27.5853 16.6293L30.2104 12.9543L27.0603 11.9043L26.0103 8.75425L22.3353 11.3793L22.7428 16.1207ZM22.7428 16.1207L19.3695 19.36",
    stroke: "url(#paint4_linear_663_3434)",
    strokeWidth: 1.33438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_663_3434",
    x1: 5.94006,
    y1: 0.352444,
    x2: 5.94006,
    y2: 55.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE2FF",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_663_3434",
    x1: 34.9974,
    y1: 25.3366,
    x2: -29.2751,
    y2: 39.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5D0FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_663_3434",
    x1: 22.1346,
    y1: 0.646029,
    x2: 26.7682,
    y2: 42.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B2FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48995,
    stopColor: "#A9CCFF",
    stopOpacity: 0.295272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E1E8FF",
    stopOpacity: 0.0821875
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FD6E6",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_663_3434",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7682 14.5396) rotate(89.968) scale(57.4732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#B5D0FB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_663_3434",
    x1: 19.3694,
    y1: 8.35156,
    x2: 19.3694,
    y2: 30.3687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2948A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67DDCB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_3434"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    y: 0.678711,
    width: 37.3625,
    height: 37.3625,
    rx: 9.34062,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSquare);
export default __webpack_public_path__ + "static/media/targetSquare.44f867a40acb48aa326825ea4c13b245.svg";
export { ForwardRef as ReactComponent };